import app from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import { firebaseConfig } from './config';

class Firebase {
    constructor(firebaseConfig) {
        app.initializeApp(firebaseConfig);
        this.auth = app.auth();
        this.db = app.firestore();
        this.storage = app.storage();
    }
    // auth actions
    doCreateUserWithEmailAndPassword = (email, password) => this.auth.createUserWithEmailAndPassword(email, password);
    doSignIn = (data) => this.auth.signInWithEmailAndPassword(data.email, data.password);
    doSignOut = () => this.auth.signOut();
    // actions with files
    doUploadFile = ({ ref, files }) => {
        const promise = file => {
            const storageRef = this.storage.ref().child(`${ref}/${Date.now()}_${file.name}`);
            return storageRef.put(file).then(snapshot => snapshot.ref.getDownloadURL());
        };
        return Promise.all([...files.map(item => promise(item))])
    }

    doGetFiles = ({ ref }) => {
        const storageRef = this.storage.ref();
        return storageRef.child(ref).listAll().then(list => {
            return Promise.all([...list.items.map(e => e.getDownloadURL())])
        })
    }

    doRemoveFile = ({ ref }) => {
        const generatedRef = this.storage.refFromURL(ref);
        return generatedRef.delete()
    }

    // actions with documents
    doGetDocument = ({ collection, document }) => this.db.collection(collection).doc(document).get().then(doc => doc.exists ? doc.data() : {});
    doSetDocument = ({ collection, document, data }) => this.db.collection(collection).doc(document || Date.now().toString()).set(data);
    doRemoveDocument = ({ collection, document }) => this.db.collection(collection).doc(document).delete()
    // gett all documents in collection
    doGetCollection = ({ collection }) => {
        return this.db.collection(collection).get();
    }
}

const fb = new Firebase(firebaseConfig);
export default fb;